const tableConfig = {
  ratio: {
    noSKU: 15,
    Description: 20,
    orderQTY: 10,
    orderReceived: 11,
    difference: 10,
    uom: 8,
    note: 12,
  },
}

export default tableConfig
